"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleDateLocalizer = simpleDateLocalizer;
exports.default = default_1;
const configure_1 = __importDefault(require("../util/configure"));
const date_format_1 = require("../util/date-format");
const date_arithmetic_1 = __importDefault(require("../util/date-arithmetic"));
function simpleDateLocalizer() {
    function endOfDecade(date) {
        date = date_arithmetic_1.default.add(date, 10, 'year');
        date = date_arithmetic_1.default.add(date, -1, 'milliseconds');
        return date;
    }
    function endOfCentury(date) {
        date = date_arithmetic_1.default.add(date, 100, 'year');
        date = date_arithmetic_1.default.add(date, -1, 'milliseconds');
        return date;
    }
    return {
        formats: {
            date: 'L',
            time: 'LT',
            default: 'lll',
            header: 'MMMM YYYY',
            footer: 'LL',
            weekday: 'dd',
            dayOfMonth: 'DD',
            month: 'MMM',
            year: 'YYYY',
            decade(date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
            },
            century(date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
            }
        },
        startOfWeek() {
            return 0;
        },
        parse(value) {
            if (!value) {
                return null;
            }
            try {
                return new Date(Date.parse(value));
            }
            catch (err) {
                console.error(err);
            }
            return null;
        },
        format(value, format) {
            return (0, date_format_1.dateFormat)(value, format);
        }
    };
}
function default_1() {
    const localizer = simpleDateLocalizer();
    configure_1.default.setDateLocalizer(localizer);
    return localizer;
}
//# sourceMappingURL=simple-date-localizer.js.map